import FreightForm from '../components/FreightForm'

export default function AddFreight() {
  

  return (
    <FreightForm initialData={null} />
  )
}
